import $ from 'jquery'
import "bootstrap"
import "regenerator-runtime"
import once from "@drupal/once"

if (typeof jQuery === 'undefined') {
  window.jQuery = $
  window.$ = $
}

var $component = once('processed', '.component-header').shift()
if ($component) {
  import("../../templates/component/header/js/header")
}
var $component = once('processed', '.component-header-search').shift()
if ($component) {
  import("../../templates/component/header-search/js/header-search")
}
var $component = once('processed', '.component-faq').shift()
if ($component) {
  import("../../templates/component/faq/js/faq")
}
var $component = once('processed', '.component-gallery').shift()
if ($component) {
  import("../../templates/component/gallery/js/gallery")
}
var $component = once('processed', '.component-store-map').shift()
if ($component) {
  import("../../templates/component/store-map/js/store-map")
}
var $component = once('processed', '.component-slideshow').shift()
if ($component) {
  import("../../templates/component/slideshow/js/slideshow")
}
var $component = once('processed', '.component-store-single').shift()
if ($component) {
  import("../../templates/component/store-single/js/store-single")
}
var $component = once('processed', '.component-contact-map').shift()
if ($component) {
  import("../../templates/component/contact-map/js/contact-map")
}
var $component = once('processed', '.component-contact-section').shift()
if ($component) {
  import("../../templates/component/contact-section/js/contact-section")
}
var $component = once('processed', '.component-product-full').shift()
if ($component) {
  import("../../templates/page/product-full/js/product-full")
}
var $component = once('processed', '.component-tiles-gallery').shift()
if ($component) {
  import("../../templates/component/tiles-gallery/js/tiles-gallery")
}
var $component = once('processed', 'body').shift()
if ($component && typeof ccnstL !== 'undefined') {
  import('../../templates/component/cookieconsent/js/cookieconsent')
}
var $component = once('processed-styleguide', 'body.styleguide').shift()
if ($component) {
  import('../../src/js/styleguide')
}
